import { ROLE_TEXTS, TODO_ROLES, UserRole } from "shared/types/roles";

const VY_DOMAIN_NAME = "@vy.no";
const TEST_DOMAIN_NAME = "@testdomenet.no";

const removeDomainNameFromUsername = (emailAddress: string) =>
  emailAddress.slice(0, emailAddress.indexOf("@"));

export const removeDomainNameIfPresent = (
  username: string | null | undefined,
) => {
  if (!username) return "";
  if (
    !(username.includes(TEST_DOMAIN_NAME) || username.includes(VY_DOMAIN_NAME))
  )
    return username;
  return removeDomainNameFromUsername(username);
};

export function getDefaultReceivingRoles(role: UserRole): UserRole[] {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- only one special case
  switch (role) {
    case UserRole.lokleder1:
    case UserRole.lokleder2:
      return [
        UserRole.materiellstyrerlokal,
        UserRole.materiellstyrerregion,
        UserRole.lokleder1,
        UserRole.lokleder2,
      ];
    case UserRole.trafikkplanlegger63:
      return [UserRole.trafikkplanlegger60];
    default:
      return [role];
  }
}

export function getAbbreviationForRole(role: UserRole): string {
  const rolesAbbreviation = ROLE_TEXTS.find(
    (roleText) => roleText.value === role,
  );
  return rolesAbbreviation!.abbreviation;
}

export function getAbbreviationForTodoRole(role: UserRole): string {
  const rolesAbbreviation = TODO_ROLES.find(
    (roleText) => roleText.value === role,
  );

  return rolesAbbreviation!.abbreviation;
}

export function getRoleFromAbbreviation(
  abbreviation: string,
): UserRole | undefined {
  return ROLE_TEXTS.find((roleText) => roleText.abbreviation === abbreviation)
    ?.value;
}
